import type { InvoiceTemplate } from '~/api/invoiceTemplates/types';

import { useIntl } from '~/hooks/useIntl';
import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  invoiceTemplate: InvoiceTemplate;
};

export const InvoiceTemplateTotalCell = ({ invoiceTemplate }: Props) => {
  const { formatCurrency } = useIntl();

  return (
    <span className={desktopTruncateStyle}>
      {invoiceTemplate.lines.length > 0 ? formatCurrency(invoiceTemplate.calculationData.coExclVat) : '–'}
    </span>
  );
};
